// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"af58f491","158":"e6f7cd5e","164":"13d8de74","415":"7610fdde","684":"4ed2b827","795":"0e1a5173"}[chunkId] + ".css";
};